

























import { defineComponent, inject } from '@vue/composition-api';
import MIDIDeviceStore from '@/stores/MIDIDeviceStore';
import PageFrame from '@/components/atoms/PageFrame.vue';
import FlatButton from '@/components/atoms/FlatButton.vue';
import SmallIcon from '@/components/atoms/SmallIcon.vue';
import { faPlug, faCog } from '@fortawesome/free-solid-svg-icons';
import MainLogo from '@/components/molecules/MainLogo.vue';
import KeyboardIcon from '@/assets/images/keyboard.svg';

export default defineComponent({
  name: 'HeaderMenu',

  components: {
    PageFrame, FlatButton, SmallIcon, MainLogo,
  },

  setup() {
    const store = inject(MIDIDeviceStore.key) as MIDIDeviceStore;
    const { state } = store;
    return {
      state, faPlug, faCog, KeyboardIcon,
    };
  },
});
